import { format, parse } from 'date-fns';
import { BookingData } from './ItineraryBody';
import { useTranslations } from '@fshr/context/i18n-context';
import { formatBeverlyWilshire } from '@fshr/shared';

type StaysSectionProps = {
	bookingData: BookingData;
};

const formatDateString = (checkIn: string, checkOut: string) => {
	if (!checkIn || !checkOut) {
		return '-';
	}
	const checkInDate = parse(checkIn, 'yyyy-MM-dd', new Date());
	const checkOutDate = parse(checkOut, 'yyyy-MM-dd', new Date());
	return `${format(checkInDate, checkInDate.getFullYear() === checkOutDate.getFullYear() ? 'MMM dd' : 'MMM dd, yy')} - ${format(checkOutDate, 'MMM dd, yy')}`;
};

export function StaysSection(props: StaysSectionProps) {
	const { bookingData } = props;
	const t = useTranslations();

	return (
		<section
			className="flex items-center justify-center px-200 py-150 md:px-300 md:py-200 border-b-[1px] border-b-border-subtle"
			aria-label={t('Stay details')}
		>
			{/* Stays Header */}
			<div className="flex items-center justify-center w-full">
				{/* Details */}
				<div className="w-full pr-100">
					{/* Content */}
					<div className="flex flex-col spacing-stack-xs">
						{/* Property Name */}
						<div className="flex flex-col spacing-stack-2xs">
							<h2 className="text-overline text-text-primary">{t('Upcoming Stay')}</h2>
							<h3
								className="text-h3 text-text-primary"
								dangerouslySetInnerHTML={{
									__html: formatBeverlyWilshire(bookingData?.propertyName),
								}}
							></h3>
						</div>
						{/* Details */}
						<dl className="flex flex-col spacing-stack-2xs">
							<div className="flex flex-col">
								<dt className="sr-only">{t('Stay dates')}</dt>
								<dd className="text-label">
									{formatDateString(bookingData?.checkInDate, bookingData?.checkOutDate)}
								</dd>
							</div>
							<div className="flex flex-col">
								<dt className="sr-only">{t('Confirmation number')}</dt>
								<dd className="text-caption">
									{t('Confirmation')} # : {bookingData?.confirmationNumber}
								</dd>
							</div>
							{bookingData?.roomType?.name && (
								<div className="flex flex-col">
									<dt className="sr-only">{t('Room type')}</dt>
									<dd className="text-caption">
										{t('Room Type')}: {bookingData.roomType.name}
									</dd>
								</div>
							)}
						</dl>
					</div>
				</div>
			</div>
		</section>
	);
}
